"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddAdsetsToCampaignRequestToJSON = exports.AddAdsetsToCampaignRequestFromJSONTyped = exports.AddAdsetsToCampaignRequestFromJSON = exports.instanceOfAddAdsetsToCampaignRequest = void 0;
var runtime_1 = require("../runtime");
var CreateFullAdsetRequest_1 = require("./CreateFullAdsetRequest");
var FeatureFlag_1 = require("./FeatureFlag");
/**
 * Check if a given object implements the AddAdsetsToCampaignRequest interface.
 */
function instanceOfAddAdsetsToCampaignRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "campaignId" in value;
    isInstance = isInstance && "adSets" in value;
    return isInstance;
}
exports.instanceOfAddAdsetsToCampaignRequest = instanceOfAddAdsetsToCampaignRequest;
function AddAdsetsToCampaignRequestFromJSON(json) {
    return AddAdsetsToCampaignRequestFromJSONTyped(json, false);
}
exports.AddAdsetsToCampaignRequestFromJSON = AddAdsetsToCampaignRequestFromJSON;
function AddAdsetsToCampaignRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'campaignId': json['campaign_id'],
        'adSets': (json['ad_sets'].map(CreateFullAdsetRequest_1.CreateFullAdsetRequestFromJSON)),
        'dryRunTrace': !(0, runtime_1.exists)(json, 'dry_run_trace') ? undefined : json['dry_run_trace'],
        'featureFlags': !(0, runtime_1.exists)(json, 'feature_flags') ? undefined : (json['feature_flags'].map(FeatureFlag_1.FeatureFlagFromJSON)),
    };
}
exports.AddAdsetsToCampaignRequestFromJSONTyped = AddAdsetsToCampaignRequestFromJSONTyped;
function AddAdsetsToCampaignRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'campaign_id': value.campaignId,
        'ad_sets': (value.adSets.map(CreateFullAdsetRequest_1.CreateFullAdsetRequestToJSON)),
        'dry_run_trace': value.dryRunTrace,
        'feature_flags': value.featureFlags === undefined ? undefined : (value.featureFlags.map(FeatureFlag_1.FeatureFlagToJSON)),
    };
}
exports.AddAdsetsToCampaignRequestToJSON = AddAdsetsToCampaignRequestToJSON;
